import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['actions', 'calendarChooser', 'calendarItem']

  connect() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(JSON.parse(this.element.dataset.bookingDetails));
  }

  addToCalendar() {
    this.showCalendarChooser(true)
  }

  showCalendarChooser(boolean) {
    const method = (boolean === true ? 'add' : 'remove')
    this.calendarChooserTarget.classList[method]('active')
    this.showActions(!boolean)
  }

  showActions(boolean) {
    const display = (boolean === true ? 'block' : 'none')
    this.actionsTarget.style.display = display
  }
}
